<template>
  <!-- 武昌福利院入院咨询 -->
  <section>
    <el-row>
      <!-- <el-col>
        <el-row class="row-title">
          
        </el-row>
      </el-col> -->
      <el-col>
        <!-- 行内表单 -->
        <el-form
          :data="searchForm"
          :inline="true"
          class="demo-form-inline toolbar"
          style="margin-top: 10px"
        >
          <el-form-item label="老人姓名">
            <el-input
              v-model.trim="searchForm.oldName"
              placeholder="姓名"
              class="small"
              clearable
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <el-form-item label="意向楼栋">
            <el-select
              v-model="searchForm.buildId"
              placeholder="请选择"
              class="small"
              @change="changeBuild"
            >
              <el-option
                v-for="item in BuilList"
                :key="item.buildingName"
                :label="item.buildingName"
                :value="item.buildingId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="意向楼层">
            <el-select
              v-model="searchForm.floorId"
              placeholder="请选择"
              class="small"
              @change="changeFloor"
            >
              <el-option
                v-for="item in getBuild.floorList"
                :key="item.value"
                :label="item.floorNo"
                :value="item.floorNo"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="意向房间">
            <el-select
              v-model="searchForm.roomId"
              placeholder="请选择"
              class="small"
              @change="changeRoom"
            >
              <el-option
                v-for="item in bedList.roomList"
                :key="item.value"
                :label="item.roomNo"
                :value="item.roomId"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="性别">
            <el-select
              v-model="searchForm.sex"
              placeholder="请选择"
              class="small"
            >
              <el-option label="全部" value></el-option>
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="入院状态">
            <el-select
              v-model="searchForm.advisoryStatus"
              placeholder="请选择"
              class="small"
            >
              <el-option label="全部" value></el-option>
              <el-option label="咨询" value="1"></el-option>
              <el-option label="入住" value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-button
            type="primary"
            plain
            icon="el-icon-search"
            @click="getconsult"
            >查询</el-button
          >
          <el-button
            type="warning"
            @click="addDialogShow"
            plain
            icon="el-icon-plus"
            >添加</el-button
          >
          <el-button
            type="primary"
            plain
            icon="iconfont icon-ic_bedroom"
            @click="jumoRoomView"
            >床位视图</el-button
          >
          <el-button type="info" @click="exportExcel" icon="el-icon-document" plain>报表导出</el-button>
        </el-form>
      </el-col>
      <el-table
        style="width: 100%"
        :data="zixunDataList"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="rowStyle"
      >
      <el-table-column
          prop="oldName"
          label="老人姓名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="oldSex"
          label="老人性别"
          width="120"
          :formatter="formatSex"
        ></el-table-column>
        <el-table-column
          prop="advisoryName"
          label="咨询人姓名"
          width="120"
        ></el-table-column>
        <!-- <el-table-column
          prop="roomNo"
          label="意向房间"
          width="120"
        ></el-table-column> -->
        <el-table-column
          prop="advisoryDate"
          label="咨询日期"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="advisoryPhone"
          label="联系电话"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="bedNo"
          label="预约床位"
          width="120"
        ></el-table-column>
        
        <!-- <el-table-column prop="remark" label="备注" min-width="120">
          <template slot-scope="scope">
            <el-popover
              placement="top-center"
              width="250"
              trigger="hover"
              :disabled="!(scope.row.remark && scope.row.remark.length > 13)"
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  margin-bottom: 5px;
                "
              >
                <h3>备注</h3>
              </div>
              <div style="cursor: default">{{ scope.row.remark }}</div>
              <span slot="reference">{{ showRemark(scope.row.remark) }}</span>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="advisoryWay"
          width="120"
          label="咨询方式"
          :formatter="formatAdvisoryWay"
        ></el-table-column>
        <el-table-column
          prop="advisoryStatus"
          width="120"
          label="咨询状态"
          :formatter="formatAdvisoryStatus"
        ></el-table-column>
        <el-table-column prop="nursingCare" width="120" label="自理状态">
        </el-table-column>
        <el-table-column label="操作" min-width="210">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="fixDialogShow(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="danger"
              size="mini"
              plain
              @click="handleRemove(scope.$index, scope.row)"
              >删除</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="warning"
              size="mini"
              plain
              :disabled="scope.row.advisoryStatus == 2"
              @click="handleAdmission(scope.$index, scope.row)"
              >入院</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              :disabled="scope.row.advisoryStatus == 3"
              @click="handleYuding(scope.$index, scope.row)"
              >预定</el-button
            >
            <!-- by yang 2021年12月8日14:25:16 修改 -->
            <!-- <a @click="fixDialogShow(scope.$index, scope.row)" class="curcor">
              <img src="@/assets/beadhouse/xiugai_icon_1.png" />
            </a> -->
            <!-- <a @click="handleRemove(scope.$index, scope.row)" class="curcor">
              <img src="@/assets/beadhouse/shanchu_icon.png" />
            </a> -->
            <!-- <a @click="handleAdmission(scope.$index, scope.row)" class="curcor">
              <img src="@/assets/beadhouse/zhuanru.png" />
            </a> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      class="fenye"
      background
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="total"
      align="center"
    ></el-pagination>
    <!-- 添加和修改咨询的弹窗 -->
    <el-dialog
      :title="isAdd ? '新增预约登记记录' : '修改预约登记表'"
      :visible.sync="adddialogVisible"
      width="60%"
      @close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="false"
    >
      <el-form
        :inline="true"
        :model="zixunAddData"
        class="demo-form-inline"
        label-width="120px"
        :rules="rules"
        ref="consultAdd"
      >
        <el-form-item label="入住老人姓名" prop="oldName">
          <el-input
            v-model="zixunAddData.oldName"
            placeholder="入住姓名"
            style="width: 204px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="老人性别" prop="oldSex">
          <el-select v-model="zixunAddData.oldSex" style="width: 204px">
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自理状态">
          <el-select v-model="zixunAddData.selfcareStatus" style="width: 204px">
            <!--
              <el-option label="自理" value="1"></el-option>
              <el-option label="半自理" value="2"></el-option>
              <el-option label="失能" value="3"></el-option>
            -->
            <el-option
              v-for="item in selfcareStatusList"
              :key="item.id"
              :label="item.nursingCare"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向房间" prop="roomNo">
          <el-input
            v-model="zixunAddData.roomNo"
            readonly
            @click.native="selectRoomdialogShow"
            style="width: 204px"
          ></el-input>
        </el-form-item>
        <el-form-item label="预约床位" prop="bedNo">
          <el-input
            v-model="zixunAddData.bedNo"
            readonly
            style="width: 204px;"
            @click.native="selectBeddialogShow"
          ></el-input>
        </el-form-item>
        <el-form-item label="咨询日期" prop="advisoryDate">
          <el-date-picker
            v-model="zixunAddData.advisoryDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 204px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="联系电话" prop="advisoryPhone">
          <el-input
            v-model="zixunAddData.advisoryPhone"
            style="width: 204px;"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="咨询人姓名" prop="advisoryName">
          <el-input v-model="zixunAddData.advisoryName"
          style="width: 204px;"></el-input>
        </el-form-item>
        <el-form-item label="与老人关系">
          <el-select v-model="zixunAddData.relationship" style="width: 204px">
            <el-option label="夫妻" value="6"></el-option>
            <el-option label="子女" value="1"></el-option>
            <el-option label="兄弟姐妹" value="2"></el-option>
            <el-option label="旁系亲属" value="3"></el-option>
            <el-option label="朋友" value="4"></el-option>
            <el-option label="其他" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备用联系方式" prop="advisoryPhoneTwo">
          <el-input v-model="zixunAddData.advisoryPhoneTwo"
          style="width: 204px;"></el-input>
        </el-form-item>
        <el-form-item label="咨询方式" prop="advisoryWay">
          <el-select v-model="zixunAddData.advisoryWay" style="width: 204px">
            <el-option label="到访" value="1"></el-option>
            <el-option label="电话" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间类型" prop="checkBedList">
          <el-checkbox-group v-model="zixunAddData.checkBedList">
            <el-checkbox label="0">单人人间带厕所</el-checkbox>
            <el-checkbox label="1">双人间带厕所</el-checkbox>
            <el-checkbox label="2">三人间带厕所</el-checkbox>
            <el-checkbox label="3">四人间带厕所</el-checkbox>
            <br />
            <el-checkbox label="4">单人间无厕所</el-checkbox>
            <el-checkbox label="5">双人间无厕所</el-checkbox>
            <el-checkbox label="6">三人间无厕所</el-checkbox>
            <el-checkbox label="7">四人间无厕所</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="老人常住地址" prop="address">
          <el-input
            v-model="zixunAddData.address"
            placeholder
            style="width: 532px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="zixunAddData.remark"
            placeholder
            type="textarea"
            maxlength="150"
            show-word-limit
            style="width: 532px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="adddialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addaskForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 房间床位选择弹窗 -->
    <el-dialog
      title
      style="margin-top: -10vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="roomBeddialogVisible"
      width="80%"
    >
      <el-row>
        <span style="margin-left: 20px">正式入住:{{ checkIn }}人</span>
        <span style="margin-left: 20px">空床:{{ nullBed }}张</span>
        <span style="margin-left: 20px">已预约:{{ order }}张</span>
        <span style="margin-left: 20px">试入住:{{ tryIn }}人</span>
        <span style="margin-left: 30px">楼栋:</span>
        <el-select
          v-model="buildName"
          placeholder="请选择"
          style="width: 120px"
          @change="selectdialogShow"
        >
          <el-option
            v-for="item in bedBuilList"
            :key="item.id"
            :label="item.buildingName"
            :value="item.buildingName"
          ></el-option>
        </el-select>
        <img
          src="@/assets/beadhouse/nan.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 30px;
          "
        />
        <span>男</span>
        <img
          src="@/assets/beadhouse/nv.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
          "
        />
        <span>女</span>
        <img
          src="@/assets/beadhouse/kongchuang_icon.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
          "
        />
        <span>空床</span>
        <img
          src="@/assets/beadhouse/yiyuyue.png"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 20px;
          "
        />
        <span>已预约</span>
      </el-row>
      <el-row>
        <room-bed-show
          v-bind:floorlist="floorList"
          v-bind:type="selectRoomtype"
          @getChildRoomBedData="clickRoomBedData"
        ></room-bed-show>
      </el-row>
    </el-dialog>
  </section>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import RoomBedShow from "@/components/RoomBedShow"; //引入第三方组件
import { baseURL } from "@/utils/request.js";
import util from "@/utils/util.js";
export default {
  name: "AdmissionConsult",
  components: {
    RoomBedShow,
  },
  data() {
    return {
      isallBuild: true,
      isall: true,
      isAdd: Boolean, //控制弹窗是添加还是修改
      //查询列表数据
      searchForm: {
        oldName: "",
        buildId: "全部",
        floorId: "全部",
        roomId: "全部",
        sex: "",
        advisoryStatus: "",
      },
      BuilList: [], //楼栋信息
      bedBuilList: [], //床位视图楼栋信息
      getBuild: [], //意向楼层信息
      bedList: [], //房间信息
      BuilListAll: [], //所有楼栋名称
      floorAll: [], //所有floor名称
      chosebuildId: 0, //查询选项的楼栋id
      choseRoomId: 0, //查询选项的房间id
      floorNum: 0, //查询选项的楼层数
      rules: {
        oldName: [
          { required: true, message: "请输入老人姓名", trigger: "blur" },
          { min: 1, max: 10, message: "长度不要超过10个字符", trigger: "blur" },
          { pattern: /[^\s]/, message: "首列不能输入空格" },
        ],
        advisoryPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
        oldSex: [{ required: true, message: "请输入性别", trigger: "c hange" }],
        advisoryName: [
          { min: 0, max: 10, message: "长度不要超过10个字符", trigger: "blur" },
        ],
        advisoryPhoneTwo: [
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
        checkBedList:[{ required: true, message: "请选择房间类型", trigger: "change" }],
        address: [
          {
            min: 0,
            max: 50,
            message: "长度不要超过50 个字符",
            trigger: "blur",
          },
        ],
        bedNo:[{ required: true, message: "请预约床位", trigger: "change" }],
        remark: [
          {
            min: 0,
            max: 150,
            message: "长度不要超过150 个字符",
            trigger: "blur",
          },
        ],
        advisoryDate: [
          { required: true, message: "请输入日期", trigger: "change" },
        ],
      },
      //添加入院登记数据
      zixunAddData: {
        oldName: "",
        oldSex: "",
        selfcareStatus: "",
        advisoryDate: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        advisoryPhone: "",
        advisoryName: "",
        relationship: "",
        advisoryPhoneTwo: "",
        advisoryWay: "",
        address: "",
        remark: "",
        bedNo: "",
        roomId: "",
        roomNo: "",
        checkBedList: [],
        id: "",
      },
      roomBiuldId: 0, //选中意向房间的楼栋id
      zixunDataList: [],
      adddialogVisible: false,
      roomBeddialogVisible: false, //dialog显示与否
      floorList: [], //子组件使用的
      currentFloorList: [],
      buildId: 0, //当前的楼栋选择id
      buildName: "",
      selectRoomtype: 2, //0代表不能点击 1代表点击房间 2代表点击床位
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      //房间入住情况
      checkIn: "0",
      nullBed: "0",
      order: "0",
      tryIn: "0",
      selfcareStatusList: [], // 护理等级列表
    };
  },
  created() {
    this.getconsult();
    this.getfloor();
    this.getIntoDetail();
    this.getSelfcareStatusList();
  },
  methods: {
    //   获取护理等级列表
    getSelfcareStatusList() {
      let params = {
        pageNum: 1,
        pageSize: 999,
        groupId: sessionStorage.getItem("groupId"),
      };
      this.$postJson("omc/levelCare/select", params).then((res) => {
        if (res.code == 200) {
          console.log(res.result.list, "6856565");
          this.selfcareStatusList = res.result.list;
        } else {
          this.selfcareStatusList = [];
        }
      });
    },
    /* 
      enter查询
    */
    enterSearchMember() {
      this.getconsult();
    },
    
    //导出
    exportExcel() {
      window.location.href =
      baseURL +
      `omc/api/downReservationZixunTableExcel?groupId=${window.sessionStorage.getItem("groupId")}`;
    },
    /* 
      获取入住信息
    */
    getIntoDetail() {
      this.$postJson("omc/Bed/queryBedStatus/" + this.buildId).then((res) => {
        //初始化床位数量
        (this.checkIn = "0"),
          (this.nullBed = "0"),
          (this.order = "0"),
          (this.tryIn = "0"),
          console.log(res);
        for (var i = 0; i < res.result.length; i++) {
          if (res.result[i].status == 0) {
            this.nullBed = res.result[i].count;
          } else if (res.result[i].status == 5) {
            this.tryIn = res.result[i].count;
          } else if (res.result[i].status == 2) {
            this.checkIn = res.result[i].count;
          } else if (
            res.result[i].status == 3 ||
            res.result[i].status == 4 ||
            res.result[i].status == 6
          ) {
            this.order = Number(this.order) + Number(res.result[i].count);
          }
        }
      });
    },
    /* 
      入院后改变样式
    */
    rowStyle({ row, rowIndex }) {
      if (row.advisoryStatus == 2) {
        return "background:#FDEDD6;pointer-events: none;";
      } else {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      }
    },

    /* 
      修改入院咨询信息
    */
    fixDialogShow(index, row) {
      console.log(row, "323232");
      this.isAdd = false;
      this.adddialogVisible = true;
      //数据回显
      this.$nextTick(() => {
        this.zixunAddData = {
          oldName: row.oldName,
          oldSex: String(row.oldSex),
          selfcareStatus: row.levelCareId *1 ? String(row.levelCareId) : "",
          advisoryDate: row.advisoryDate,
          advisoryPhone: row.advisoryPhone,
          advisoryName: row.advisoryName,
          relationship: row.relationship ? String(row.relationship) : "",
          advisoryPhoneTwo: row.advisoryPhoneTwo,
          advisoryWay: row.advisoryWay ? String(row.advisoryWay) : "",
          address: row.address,
          remark: row.remark,
          bedNo: row.bedNo,
          roomId: row.roomId,
          roomNo: row.roomNo,
          id: row.id,
          checkBedList: [],
        };
        //处理意向房间类型
        let intentionBedArr = row.intentionBed.split(",");
        let intentionBedIndex = [];
        for (var i = 0; i < intentionBedArr.length; i++) {
          if (intentionBedArr[i] == 1) {
            this.zixunAddData.checkBedList.push(i.toString());
          }
        }
      });
    },

    //添加咨询记录
    addDialogShow() {
      this.adddialogVisible = true;
      this.isAdd = true;
      this.zixunAddData.advisoryDate = util.formatDate.format(
        new Date(),
        "yyyy-MM-dd"
      );
    },
    /* 
      关闭弹窗的回调
    */
    closeDialog() {
      this.$refs["consultAdd"].resetFields();
      this.zixunAddData = {
        selfcareStatus: "",
        relationship: "",
        advisoryWay: "",
        roomNo: "",
        bedNo: "",
        checkBedList: [],
      };
      this.roomBiuldId = 0;
    },
    selectRoomdialogShow() {
      this.selectRoomtype = 1;
      this.selectdialogShow();
    },
    selectBeddialogShow() {
      this.selectRoomtype = 2;
      this.selectdialogShow();
    },

    /* 
      转入院
    */
    handleAdmission(index, row) {
      this.$confirm("确定要为当前老人转入院吗？", "咨询转入院", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        center: true,
      })
        .then(() => {
          //by guo 2019-09-03 18:56 添加  用于在基本信息页面返回此页面
          sessionStorage.removeItem("editOldmanId"); //by guo 2019-09-04 添加  清除oldmanId
          sessionStorage.setItem("hospitalType", 3); //by guo 2019-09-04 添加咨询入住跳转到基本信息录入的时候是hospitalType=3
          // row
          sessionStorage.setItem("zixunRow",JSON.stringify(row));
          //跳转到入院详情
          bus.$emit("homePage", {
            type: "jump",
            // path: "/OlderDetailAddBase",//by guo 2019-09-04 10:27 传值会有bug 注释掉
            path: "/OlderDetailAdd", //by guo 2019-09-04 10:27 修改 需要先传递到OlderDetailAdd然后在间接的传递到OlderDetailAddBase
            title: "入院详情",
            params: {
              olamanRow: row,
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消转入院",
          });
        });
    },

    handleYuding(index, row) {
      let that = this;
      this.$confirm("确定要为当前老人转预定吗？", "咨询转预定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        center: true,
      })
        .then(() => {
          that.$postJson("omc/advisory/edit", {
            advisoryStatus:3,
            id: row.id
          }).then((res) => {
            if (res.code == 200) {
              that.getconsult();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消转预定",
          });
        });
    },


    //获取入院咨询信息
    getconsult() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNumber,
        oldName: this.searchForm.oldName,
        buildingId: this.chosebuildId,
        roomId: this.choseRoomId,
        floorNo: Number(this.floorNum),
        oldSex: this.searchForm.sex == "" ? "" : Number(this.searchForm.sex),
        advisoryStatus:
          this.searchForm.advisoryStatus == ""
            ? ""
            : Number(this.searchForm.advisoryStatus),
      };
      this.$postJson("omc/advisory/queryListWithPage", params).then((res) => {
        if (res.code == 200) {
          console.log(res.result.list, "22222");
          this.total = Number(res.result.total);
          this.zixunDataList = res.result.list;
        } else {
          this.zixunDataList = [];
        }
      });
    },

    //表格数据转换
    formatSex: function (row) {
      return row.oldSex == 0 ? "男" : row.oldSex == 1 ? "女" : "未知";
    },
    formatAdvisoryWay: function (row) {
      if (row.advisoryWay == 1) {
        return "到访";
      } else if (row.advisoryWay == 2) {
        return "电话";
      }
    },
    formatAdvisoryStatus: function (row) {
      if (row.advisoryStatus == 1) {
        return "咨询";
      } else if (row.advisoryStatus == 2) {
        return "入住";
      }else if (row.advisoryStatus == 3) {
        return "预定";
      }
    },
    // formatSelfcareStatus: function (row) {
    //   var title = ''
    //   this.selfcareStatusList.forEach((item) => {
    //     if (item.id == row.selfcareStatus) {
    //       title = item.nursingCare
    //     }
    //   })  
    //   return title
    //   // return row.selfcareStatus
    //   //   if (row.selfcareStatus == 1) {
    //   //     return '自理'
    //   //   } else if (row.selfcareStatus == 2) {
    //   //     return '半自理'
    //   //   } else if (row.selfcareStatus == 3) {
    //   //     return '失能'
    //   //   }
    // },
    //获取楼栋信息
    getfloor() {
      this.$postForm("omc/Building/showAlls").then((res) => {
        this.bedBuilList = res.result.concat();
        this.BuilList = res.result;
        this.buildName = res.result[0].buildingName; //初始化房间楼栋
        this.BuilList.unshift({
          buildingName: "全部",
          buildingId: 0,
        });
      });
    },

    //根据所选楼栋显示楼层数
    changeBuild(val) {
      if (val == 0) {
        (this.floorNum = 0), (this.choseRoomId = 0);
      }
      this.bedList = [];
      this.searchForm.floorId = "全部";
      this.searchForm.roomId = "全部";
      this.chosebuildId = val;
      let list = this.BuilList;
      this.getBuild = list.find((item) => {
        return item.buildingId == val;
      });
      if (this.getBuild.floorList[0].floorNo != "全部") {
        this.getBuild.floorList.unshift({
          floorNo: "全部",
        });
      }
    },

    //根据所选楼层数显示楼层
    changeFloor(val) {
      if (val == "全部") {
        this.choseRoomId = 0;
      }
      this.searchForm.roomId = "全部";
      this.floorNum = val;
      let room = this.getBuild.floorList;
      this.bedList = room.find((item) => {
        return item.floorNo == val;
      });
      if (this.bedList.roomList[0].roomNo != "全部") {
        this.bedList.roomList.unshift({
          roomNo: "全部",
          roomId: "0",
        });
      }
    },

    //根据楼层显示房间
    changeRoom(val) {
      this.choseRoomId = val;
      let bed = this.bedList.roomList;
      let getbedList = bed.find((item) => {
        return item.roomId == val;
      });
    },

    //删除当前选中的行
    handleRemove(index, row) {
      // if (row.bedNo) {
      //   this.$alert("该老人已预约病床暂不能删除", "提示", {
      //     confirmButtonText: "确定",
      //     center: true,
      //   }).catch(() => {});
      // } else 
      // {
        this.$confirm("此操作将永久删除该预约, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          center: true,
        }).then(() => {
            let id = Number(row.id);
            this.$postJson("omc/advisory/deleteById/" + id).then((res) => {
              if (res.code == "200") {
                this.$message({ message: "操作成功", type: "success" });
                this.getconsult(); //重新渲染页面
              } else {
                this.$message(
                  this.$message({
                    message: "操作失败, " + res.message,
                    type: "error",
                  })
                );
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      // }
    },
    //翻页
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getconsult();
    },
    //选择房间床位弹窗显示
    selectdialogShow() {
      let aa = this.BuilList;
      let build = aa.filter((item) => {
        return item.buildingName == this.buildName;
      });
      //this.floorList = build[0].floorList;
      this.buildId = build[0].buildingId;
      this.getBuildFloorList();
      this.getIntoDetail();
    },

    getBuildFloorList() {
      this.$postForm("omc/Room/showAll", { buildingId: this.buildId }).then(
        (res) => {
          if (res.result) {
            this.currentFloorList = res.result.floorList;
            this.controlFloorData();
          } else {
            this.currentFloorList = [];
            this.controlFloorData();
          }
        }
      );
    },
    //处理楼层全部数据
    controlFloorData() {
      //为了一个房间太多床位的显示异常
      let floorList = [];
      for (let i = 0; i < this.currentFloorList.length; i++) {
        let roomList = [];
        //获取房间列表
        for (let j = 0; j < this.currentFloorList[i].roomList.length; j++) {
          let pageList = [];
          this.currentFloorList[i].roomList[j] = this.getBedSrc(
            this.currentFloorList[i].roomList[j]
          );
          let allBedList = this.currentFloorList[i].roomList[j].bedList;
          //切割数组,然后进行分页添加上去
          for (var k = 0; k < allBedList.length; k += 4) {
            var bedList = allBedList.slice(k, k + 4);
            pageList.push({
              bedList: bedList,
            });
          }
          let roomData = {
            roomno: this.currentFloorList[i].roomList[j].roomNo,
            roomId: this.currentFloorList[i].roomList[j].roomId,
            roomType: this.currentFloorList[i].roomList[j].roomType,
            pageList: pageList,
          };
          roomList.push(roomData);
        }

        let floorData = {
          floorNo: this.currentFloorList[i].floorNo,
          roomList: roomList,
        };
        floorList.push(floorData);
      }
      this.floorList = floorList;
      this.roomBeddialogVisible = true;
    },
    //根据房间和床位,设置它的src,如果需要修改显示的逻辑,请修改这里
    getBedSrc(roomData) {
      var bedList = roomData.bedList;
      roomData.bedList.forEach((bedItem) => {
        //试入住
        if (bedItem.status == 5) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/shiruzhu_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/shiruzhu_nv.png");
          }
        }

        //入住
        if (bedItem.status == 2) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/nv.png");
          }
        }

        //预约
        if (bedItem.status == 3) {
          bedItem.src = require("@/assets/beadhouse/yiyuyue.png");
        }

        //空床
        if (bedItem.status == 0) {
          bedItem.src = require("@/assets/beadhouse/kongchuang_icon.png");
        }

        //待缴费
        if (bedItem.status == 7) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nv.png");
          }
        }

        //调房调级中
        if (bedItem.status == 6) {
          bedItem.src = require("@/assets/beadhouse/tiaozhengzhong_nan.png");
        }
      });
      return roomData;
    },
    //表单上传
    addaskForm() {
      console.log(this.zixunAddData.selfcareStatus, "9696");
      let intentionBed = [0, 0, 0, 0, 0, 0, 0, 0];
      for (var i = 0; i < this.zixunAddData.checkBedList.length; i++) {
        intentionBed.splice(this.zixunAddData.checkBedList[i], 1, 1);
      }
      let NewintentionBed = intentionBed.toString();
      console.log(NewintentionBed);
      this.$refs["consultAdd"].validate((valid) => {
        //表单校验
        if (valid) {
          //根据添加还是修改传不同的参数
          let params = {
            //id:Number(this.zixunAddData.id),
            advisoryPhone: this.zixunAddData.advisoryPhone,
            oldName: this.zixunAddData.oldName,
            oldSex: Number(this.zixunAddData.oldSex),
            levelCareId: Number(this.zixunAddData.selfcareStatus),
            advisoryDate: this.zixunAddData.advisoryDate,
            advisoryName: this.zixunAddData.advisoryName,
            relationship: Number(this.zixunAddData.relationship),
            advisoryPhoneTwo: this.zixunAddData.advisoryPhoneTwo,
            advisoryWay: Number(this.zixunAddData.advisoryWay),
            address: this.zixunAddData.address,
            remark: this.zixunAddData.remark,
            bedId: this.zixunAddData.bedId,
            roomId: this.zixunAddData.roomId,
            buildingId: this.roomBiuldId,
            // intentionRoomNo: this.zixunAddData.roomNo,
            intentionBed: NewintentionBed,
          };
          if (!this.isAdd) {
            params.id = Number(this.zixunAddData.id);
          }
          console.log(params, "123456");
          this.$postJson(
            this.isAdd ? "omc/advisory/add" : "omc/advisory/edit",
            params
          ).then((res) => {
            if (res.code == "200") {
              this.$message({ message: res.message, type: "success" });
              this.adddialogVisible = false; //关闭弹窗
              this.$refs["consultAdd"].resetFields();
              this.getconsult();
              this.getIntoDetail(); //刷新床位表
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取子路由向父路由传值
    clickRoomBedData(data) {
      if (data.type == 1) {
        this.zixunAddData.roomNo = data.roomno;
        this.zixunAddData.roomId = data.roomId;
        this.roomBiuldId = data.buildId;
        this.roomBeddialogVisible = false;
      } else if (data.type == 2) {
        if (data.bedtype.status == 3) {
          this.$alert("该床位已被预约,请重新选择", "提示", {
            confirmButtonText: "确定",
            center: true,
          }).catch(() => {});
        } else if (
          data.bedtype.status == 2 ||
          data.bedtype.status == 5 ||
          data.bedtype.status == 7
        ) {
          this.$alert("该床位已入住,请重新选择", "提示", {
            confirmButtonText: "确定",
            center: true,
            closeOnClickModal: false,
          });
        } else if (data.bedtype.status == 6) {
          this.$alert("该床位正在调整中,请重新选择", "提示", {
            confirmButtonText: "确定",
            center: true,
            closeOnClickModal: false,
          });
        } else {
          this.zixunAddData.bedNo = data.bedno;
          this.zixunAddData.bedId = data.bedid;
          this.roomBeddialogVisible = false;
        }
      }
    },

    /* 
      床位视图
    */
    jumoRoomView() {
      this.roomBeddialogVisible = true;
      this.selectRoomtype = 0;
      this.floorList = this.bedBuilList[0].floorList;
      this.selectdialogShow();
    },
    showRemark(cellVal) {
      let val = "";
      if (cellVal) {
        if (cellVal.length > 13) {
          val = cellVal.substring(0, 13) + "...";
        } else {
          val = cellVal;
        }
      }
      return val;
    },
  },
  mounted() {
    //入院后刷新界面
    this.$bus.$on("changeStatus", () => {
      this.getconsult();
    });
  },
};
</script>
<style lang="scss" scoped>

.toolbar{
  padding-left: 8px;
  padding-top: 5px;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
.cell {
  cursor: default;
}
.small {
  width: 120px;
}
.curcor {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}
.fenye {
  padding: 30px 0;background: #fff;
}
</style>
